import { WatDatPho } from "./WatDatPho";
import './../node_modules/font-awesome/css/font-awesome.min.css';
import './../node_modules/bootstrap/dist/css/bootstrap.css';
import './../node_modules/onepage-scroll/jquery.onepage-scroll.js';
import './../node_modules/onepage-scroll/onepage-scroll.css';
import './css/style.css';

const watDatPho = new WatDatPho();


// WEBPACK FOOTER //
// ./src/index.ts